module.exports = __webpack_public_path__ + "static/media/features-section-image-2.8bbb377d.png";